"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var button_1 = require("../../../../components/pricing/buttons/button/button");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

exports.PageButtons = function (props) {
  var buttons = props.buttons;
  return react_1.default.createElement(react_native_1.View, {
    style: [theme_pricing_system_1.pricingStyles.pageButtonsViewStyle, props.viewStyle]
  }, buttons.map(function (button, index) {
    return react_1.default.createElement(button_1.Button, {
      key: index,
      label: button.text,
      onPress: button.onPress,
      type: button.type,
      disabled: button.disabled
    });
  }));
};